export default "__VITE_ASSET__e03c2a5e__"